import React, {FC} from "react"

interface IFlag {
    code:string
}

const Flag:FC<IFlag> = ({code}):React.ReactElement => {
    return <i className={`flag-icon flag-icon-${code}`}/>
}

export default React.memo(Flag)
